{
  "newTitle": "New Module",
  "editTitle": "Edit Module",
  "saveLabel": "Save module",
  "savingLabel": "Saving",
  "titleLabel": "Title",
  "titlePlaceholder": "Module Title",
  "descriptionLabel": "Description",
  "descriptionPlaceholder": "What this module covers",
  "thumbnailLabel": "Thumbnail",
  "keepCurrentImage": "Keep current image",
  "clearImage": "Clear",
  "campusLabel": "Campus",
  "campusPlaceholder": "Select a campus",
  "categoryLabel": "Category",
  "categoryPlaceholder": "Select a category",
  "uploadTargetFailed": "Unable to create an upload target for the thumbnail.",
  "uploadFailed": "The thumbnail upload failed. Please try again."
}
